import AwardCard from "../components/AwardCard";
import { useTranslation } from "react-i18next";


const Awards = () => {
  const {t} = useTranslation()
  const awardsData = t('awardsData', { returnObjects: true });
  

  return (
    <section className="mt-8 md:mt-16 pb-10 md:pb-20 p-4">
      <h2 className="text-lg md:text-[40px] text-center font-semibold">{t('awards')}</h2>
      <div className="mt-10 flex flex-col gap-6 justify-center items-center">
        {awardsData[0].map((el) => {
          return <AwardCard {...el} />;
        })}
      </div>
    </section>
  );
};

export default Awards;
